import { render } from "./ItemListHeadMid.vue?vue&type=template&id=2f5f54c6&scoped=true"
import script from "./ItemListHeadMid.vue?vue&type=script&lang=js"
export * from "./ItemListHeadMid.vue?vue&type=script&lang=js"

import "./ItemListHeadMid.vue?vue&type=style&index=0&id=2f5f54c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5f54c6"]])

export default __exports__